// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__TcxtM","info":"Panel_info__FXU4W","btns":"Panel_btns__em-yB","button":"Panel_button__mSQBW"};